const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Formats an ISO time as "12 Oct 2026" in UTC. Empty text for a bad value. */
export function formatCertificateDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return '';
  }

  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** Formats an ISO time as "14:05 UTC". Empty text for a bad value. */
export function formatCertificateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return '';
  }

  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');

  return `${hh}:${mm} UTC`;
}

/** Formats an ISO time as "13 Oct 2026, 15:41 UTC". Empty text for a bad value. */
export function formatCertificateDateTime(iso: string): string {
  const date = formatCertificateDate(iso);
  if (!date) {
    return '';
  }

  return `${date}, ${formatCertificateTime(iso)}`;
}

/** Date and time for admin tables and details. A dash for an empty or bad value. */
export function formatAdminDate(value?: string): string {
  if (!value) {
    return '-';
  }

  return formatCertificateDateTime(value) || '-';
}
